import React from 'react';
export function EditorPastePlainIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zM11 16a1 1 0 100 2h6a1 1 0 100-2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 2a1 1 0 00-1 1v14.5a1 1 0 102 0V4h12v2H7a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V7a1 1 0 00-1-1h-3V3a1 1 0 00-1-1H3zm5 18V8h12v12H8z"
  }));
}